/**
 * Alpine JS
 * Best to put it last so that all other potential JS is available
 * when components start getting initialized.
 */

import Alpine from "alpinejs";
import AOS from "aos";
import collapse from "@alpinejs/collapse";

import { serviceFormSummary } from "./components/serviceFormSummary.js";
import { refreshCsrf } from "./components/refreshCsrf.js";
import { loadDatePicker, toNorwegianDate } from "./components/loadDatePicker.js";
import { loadScript } from "./components/loadScript.js";

// available to the date fields before Alpine starts
window.loadDatePicker = loadDatePicker;
window.toNorwegianDate = toNorwegianDate;
window.loadScript = loadScript;

Alpine.plugin(collapse);

window.Alpine = Alpine;
Alpine.start();

// animation
AOS.init();
serviceFormSummary();

window.refreshCsrf = refreshCsrf;
/*let itemArray = [
    {
        key: "fields[sted]",
        value: "orgNumber"
    },
    {
        key: "fields[companyName]",
        value: "companyDisplay"
    }
];

document.addEventListener("DOMContentLoaded", function () {
    let hiddenInput = document.querySelector('input[name="handle"][value="serviceskjema"]');

    if (hiddenInput) {
        let form = hiddenInput.closest("form");

        if (form) {
            form.addEventListener('onAfterFormieSubmit', (e) => {
                e.preventDefault();

                itemArray.forEach(item => {
                    setSummaryValue(form, item.key, item.value);
                });
                // let item = null;

                // item = form.querySelector('input[name="fields[sted]"]');
                // if (item) {
                //     form.querySelector('#orgNumber').innerHTML = item.value;
                // }
            });
        }
    }
});

function setSummaryValue(form, key, value) {
    let item = null;
    item = form.querySelector('input[name="' + key + '"]');
    if (item) {
        form.querySelector('#' + value).innerHTML = item.value;
    }
}*/
